module.exports = __webpack_public_path__ + "static/undraw_researching_22gp-4371ea2bfc6ee2c83bad983260e60a40.svg";